import {combineReducers} from 'redux';

import proxies from './proxies/proxies';

export default combineReducers({
    proxies,
});
